/**
 * Groups the entries of an array by the value of a specific key
 * 
 * ex: ([{ a: 1, x: 1 }, { a: 1, x: 2 }, { a: 2, x: 1 }], 'a') =>
 *  {
 *    "1": [{ a: 1, x: 1 }, { a: 1, x: 2 }],
 *    "2": [{ a: 2, x 1 }]
 *  }
 */
export const groupByKey = <T extends Record<any, any>, K extends keyof T>(items: T[], key: K) =>
  items.reduce((bins, item) => {
    bins[item[key]] ||= [];
    bins[item[key]].push(item);
    return bins;
  }, {} as Record<T[K], T[]>)
